// Модалка. Уведомления (Колокольчик)
export const MODAL_NOTIFY = "MODAL_NOTIFY";

// Модалка. Профиль
export const MODAL_PROFILE = "MODAL_PROFILE";

// Модалка с фильтрами для мобильных устройств
export const MODAL_MOBILE_FILTERS = "MODAL_MOBILE_FILTERS";

// Модалка - Активировать канал
export const MODAL_ACTIVATE_CHANNEL = "MODAL_ACTIVATE_CHANNEL";

// Тип устройства (desktop or mobile)
export const DEVICE_TYPE = "DEVICE_TYPE";

// Список инстансов
export const INSTANCES = "INSTANCES";

// Подробная информация об инстансе
export const INSTANCE = "INSTANCE";

// Состояние запроса карточки отделяет отказ в доступе от ошибки загрузки.
export const INSTANCE_LOAD_STATUS = "INSTANCE_LOAD_STATUS";

export type InstanceLoadStatus =
	| "idle"
	| "loading"
	| "loaded"
	| "forbidden"
	| "error";

// Создаем инстанс
export const INSTANCE_CREATE = "INSTANCE_CREATE";

// Переход на другую страницу
export const REDIRECT = "REDIRECT";

// Удаляем инстанс
export const INSTANCE_DELETE = "INSTANCE_DELETE";

// Модалка. Получить QR код
export const MODAL_QR_CODE = "MODAL_QR_CODE";

// Получить QR код
export const QR_CODE = "QR_CODE";

// Перезагружаем инстанс
export const INSTANCE_REBOOT = "INSTANCE_REBOOT";

// Logout instance
export const INSTANCE_LOGOUT = "INSTANCE_LOGOUT";

// Сохраняем настройки
export const INSTANCE_SET_SETTINGS = "INSTANCE_SET_SETTINGS";

// Модалка. Лог действий
export const MODAL_EVENT_LOG = "MODAL_EVENT_LOG";

// Лог действий
export const EVENT_LOG = "EVENT_LOG";

// Лог действий. Запись события
export const SEND_EVENT_LOG = "SEND_EVENT_LOG";

// Список опций для покупок
export const OPTION_LIST = "OPTION_LIST";
